import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

/*
Setting up the tracking ID
*/
const trackingID = 'UA-183899599-1';
const pixelID = '840187633439375';

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};

function init() {
  ReactGA.initialize(trackingID);
  ReactPixel.init(pixelID, false, options);

  console.log('React Analytics Initialised');
}

function customEvent(category, action) {
  if (category === 'USER' && action === 'Buy Bundle Clicked') {
    ReactPixel.track('track', 'AddToCart');
  }
  ReactGA.event({
    category,
    action,
  });
  console.log('Created Event For: ' + category + ' with action: ' + action);
}

function set(object) {
  ReactGA.set(object);
}

function pageView(location) {
  ReactPixel.pageView(); // For tracking page view
  ReactGA.pageview(location);
  console.log('Logged At: ' + location);
}

export { init, customEvent, pageView, set };
